// initial state
const getDefaultState = () => {
  return {
    isActive: false,
    basicInfo: {
      pipeline: null,
      fName: null,
      lName: null,
      email: null,
      phone: null,
      designIdeas: null,
      productInterest: {
        ties: false,
        bowTies: false,
        pocketSquares: false,
        infinityScarves: false,
        chiffonScares: false
      },
      deadline: null,
      adSource: null,
      segment: "individual",
      saved: false
    },
    colors: {
      primary: {
        colorName: "",
        hex: "#dddddd",
        colorSet: ""
      },
      secondary: {
        colorName: "",
        hex: "#dddddd",
        colorSet: ""
      },
      accent1: {
        colorName: "",
        hex: "#dddddd",
        colorSet: ""
      },
      accent2: {
        colorName: "",
        hex: "#dddddd",
        colorSet: ""
      },
      accent3: {
        colorName: "",
        hex: "#dddddd",
        colorSet: ""
      }
    },
    uploadedFiles: {
      files: [],
      saved: false
    }
  };
};

const state = getDefaultState();

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {
  setColors(state, color) {
    state.colors[color.selection] = color;
  },
  clearColor(state, placement) {
    state.colors[placement] = {
      colorName: "",
      hex: "#dddddd",
      colorSet: ""
    };
  },
  setBasicInfo(state, info) {
    state.basicInfo = info;
    state.basicInfo.saved = true;
    state.isActive = true;
  },
  setUploadedFiles(state, files) {
    state.uploadedFiles.files = files;
    state.uploadedFiles.saved = true;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/newIndProject.js